import React, {useState} from "react";
import { faq } from "../../images";
import { ChevronDown, ChevronUp, HelpCircle } from "lucide-react";
import { motion } from "framer-motion";

interface QuestionData {
   id:number;
   question: string;
   answer: string;
 }
const questions: QuestionData[] = [
   {id:1,
      question: "What is our platform's primary purpose?",
      answer: "Our platform is designed to connect students with expert tutors, providing interactive online learning experiences across various subjects.",
    },
  {
      id:2,
      question: "How do teachers register to teach?",
      answer: "Teachers can easily register by filling out a simple form on our website. They choose their preferred subjects, provide their qualifications, and submit their profile for approval. Once approved, they can start offering their expertise to students.",
    },
  {
      id:3,
      question: "What features do we offer students?",
      answer: "Students can register to select their desired subjects and connect with qualified tutors. Our platform includes features like video conferencing, a digital library, and tools for assignments and projects, enhancing the online learning experience.",
    },
  {
      id:4,
      question: "How can students submit assignments?",
      answer: "Students can submit assignments directly through the platform. Our user-friendly interface allows for easy uploads and communication with tutors, ensuring feedback and support are just a click away.",
    },
  {
      id:5,
      question: "What makes us different from other platforms?",
      answer: "We prioritize personalized learning experiences by connecting students with passionate tutors. Our interactive features, such as live video sessions and collaborative project tools, set us apart in the online education landscape.",
    },
  {
      id:6,
      question: "Is there support available for users?",
      answer: "Absolutely! Our dedicated support team is available 24/7 to assist both students and teachers with any inquiries or technical issues, ensuring a seamless learning experience.",
    },
];



const FrequentlyAskedQuestions: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index:any) => {
  setActiveIndex(activeIndex === index ? null : index);
};
  return (
    <section className="w-full bg-slate-50 shadow-md">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        {/* Header */}
        <div className="text-center mb-12">
          <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.5 }} className="text-3xl sm:text-4xl lg:text-5xl font-bold text-zinc-600 mb-4">
            Frequently Asked Questions
          </motion.h1>
          <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.5 }} className="text-lg sm:text-xl lg:text-2xl text-neutral-400 font-medium">
            Have questions? We have answers
          </motion.p>
        </div>

        {/* FAQ Items */}
        <div className="max-w-3xl mx-auto space-y-4">
          {questions.length > 0 ? (
            questions.map((faq, index) => (
              <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.5 }}
                key={index}
                className="border border-zinc-200 rounded-lg overflow-hidden hover:border-zinc-300 transition-colors duration-200">
                <button
                  type="button"
                  onClick={() => toggleAccordion(faq.id)}
                  className="w-full text-left p-4 sm:p-6 flex items-center justify-between gap-4 bg-white hover:bg-slate-50 transition-colors duration-200">
                  <div className="flex items-center gap-3 flex-1">
                    <HelpCircle className="w-5 h-5 text-indigo-500 flex-shrink-0" />
                    <span className="text-base sm:text-lg font-medium text-zinc-800">
                      {faq.question}
                    </span>
                  </div>
                  {activeIndex === faq.id ? (
                    <ChevronUp className="w-5 h-5 text-zinc-400" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-zinc-400" />
                  )}
                </button>

                {/* Answer */}
                {activeIndex === faq.id && (
                  <div className="bg-white px-4 sm:px-6 py-4">
                    <p className="text-sm sm:text-base text-zinc-600 leading-relaxed ml-8">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </motion.div>
            ))
          ) : (
            <p className="text-center text-zinc-500">No FAQs available</p>
          )}
        </div>

        {/* See More Button */}
        <div className="text-center mt-8 sm:mt-12">
          <button className="bg-indigo-500 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            See more
          </button>
        </div>
      </div>
    </section>
  );
};

export default FrequentlyAskedQuestions;
